import React from "react";
import { Filter, BarChart3, MessageSquare, GitMerge } from "lucide-react";
import { cn } from "../../lib/utils";
import { FEATURES } from "../../lib/constants";
import { SectionHeader } from "../ui/Divider";

const iconMap = {
  Filter,
  BarChart3,
  MessageSquare,
  GitMerge,
};

export function Features({ className }) {
  return (
    <section
      className={cn(
        "py-12 md:py-16 px-4",
        "bg-paper-dark/30",
        className
      )}
    >
      <div className="max-w-5xl mx-auto">
        <SectionHeader
          title="What You'll Receive"
          subtitle="Every issue of The Arabian-Nubian Brief delivers actionable intelligence crafted for mining professionals."
        />

        {/* Features - Alternating Layout */}
        <div className="space-y-12 md:space-y-16">
          {FEATURES.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            const isEven = index % 2 === 0;

            return (
              <div
                key={feature.title}
                className={cn(
                  "scroll-animate",
                  "flex flex-col md:flex-row items-center gap-6 md:gap-12",
                  !isEven && "md:flex-row-reverse"
                )}
                style={{ transitionDelay: `${index * 0.1}s` }}
              >
                {/* Icon */}
                <div
                  className={cn(
                    "flex-shrink-0",
                    "w-20 h-20 md:w-24 md:h-24",
                    "bg-paper rounded-lg",
                    "border-2 border-gold",
                    "flex items-center justify-center",
                    "shadow-md",
                    // Art Deco corner accents
                    "relative",
                    "before:absolute before:top-1 before:left-1 before:w-3 before:h-3 before:border-t before:border-l before:border-gold/50",
                    "after:absolute after:bottom-1 after:right-1 after:w-3 after:h-3 after:border-b after:border-r after:border-gold/50"
                  )}
                >
                  {Icon && <Icon className="w-10 h-10 md:w-12 md:h-12 text-gold" />}
                </div>

                {/* Content */}
                <div
                  className={cn(
                    "flex-1",
                    "text-center md:text-left",
                    !isEven && "md:text-right"
                  )}
                >
                  <h3 className="font-serif text-2xl font-bold text-ink mb-3">
                    {feature.title}
                  </h3>
                  <p className={cn(
                    "font-body text-ink-secondary leading-relaxed max-w-lg",
                    !isEven && "md:ml-auto"
                  )}>
                    {feature.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
